/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dd_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free date calculator — days, weeks, months and weekdays between two dates, plus a countdown from today. Instant, in your browser.`)
};

const es_dd_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de fechas gratuita — días, semanas, meses y días de semana entre dos fechas, más una cuenta atrás desde hoy. Al instante, en tu navegador.`)
};

const de_dd_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlos Datumsrechner — Tage, Wochen, Monate und Wochentage zwischen zwei Daten, plus Countdown von heute. Sofort in Ihrem Browser.`)
};

const nl_dd_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis datumcalculator — dagen, weken, maanden en weekdagen tussen twee datums, plus een aftelling van vandaag af. Direct, in je browser.`)
};

const fr_dd_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculatrice de dates gratuite — jours, semaines, mois et jours de la semaine entre deux dates, plus un compte à rebours à partir d'aujourd'hui. Instantané, dans votre navigateur.`)
};

const it_dd_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore di date gratuito — giorni, settimane, mesi e giorni feriali tra due date, più un conto alla rovescia da oggi. Istantaneo, nel tuo browser.`)
};

const pt_br2_dd_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de datas gratuita — dias, semanas, meses e dias úteis entre duas datas, mais uma contagem regressiva de hoje. Instantâneo, no seu navegador.`)
};

const pt_dd_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de datas gratuita — dias, semanas, meses e dias da semana entre duas datas, além de uma contagem regressiva a partir de hoje. Instantâneo, no seu navegador.`)
};

const ja_dd_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の日付計算機 — 2つの日付間の日数、週、月、平日、および本日からのカウントダウン。ブラウザで即座に。`)
};

const zh_dd_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费日期计算器——计算两个日期之间的天数、周数、月数和工作日数，还可从今天开始倒计时。即时计算，直接在浏览器中完成。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dd_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dd_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dd_tool_description", locale)
	if (locale === "en") return en_dd_tool_description(inputs)
	if (locale === "es") return es_dd_tool_description(inputs)
	if (locale === "de") return de_dd_tool_description(inputs)
	if (locale === "nl") return nl_dd_tool_description(inputs)
	if (locale === "fr") return fr_dd_tool_description(inputs)
	if (locale === "it") return it_dd_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_dd_tool_description(inputs)
	if (locale === "pt") return pt_dd_tool_description(inputs)
	if (locale === "ja") return ja_dd_tool_description(inputs)
	return zh_dd_tool_description(inputs)
};